import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Service from '../../../../../services/clientmanagement.service';
import ViewDetailsComponent from './../../../../../../shared/components/viewdetails';

export default {
	name: 'otherinformation',
	components: {
		VueElementLoading,
		ViewDetailsComponent
	},
	props: ['viewRow','selectclientSystemID','selectBusinessAccId'],
	data() {
		return {
			isLoading : false,
			productData : null,
			safetyInfoData : null,
			securityInfoData : null,
			boxDimestionData : null,
			commercialProjectionsData : null,
			manifestData : null,
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false, 4:false, 5:false, 6:false}
		}
	},
	computed: {

	},
	async mounted() {
		if(this.selectclientSystemID){
			this.getOtherInfoTab(this.selectclientSystemID,this.selectBusinessAccId);
		}else{
			this.getClientBasicDetails(this.selectBusinessAccId);
		}
	},
	methods: {
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		async getClientBasicDetails(clientbusinessaccountid){
			this.isLoading = true;
			let inputpayload = {
			  "clientid": clientbusinessaccountid
			}
			let clientdata = await Service.getClientBasicDetails(inputpayload);
			this.isLoading = false;
			let clientid = clientdata.data.data.data.ClientMasterID;
			this.getOtherInfoTab(clientid,this.selectBusinessAccId);
		},
		async getOtherInfoTab(clientid, clientbusinessaccountid){
			this.isLoading = true;
			let payload = {
				clientid : clientid,
				clientbusinessaccountid : clientbusinessaccountid
			}
			let result = await Service.getOtherInformationForClientList(payload);
			if (result.data.code == 200) {
				let otherinfodata = result.data.data;
				if (otherinfodata) {
					if (otherinfodata.productcategories && otherinfodata.avgshipmentwt) {
						let productcategories = [];
						for(var i=0; i< otherinfodata.productcategories.length; i++){
							productcategories.push(otherinfodata.productcategories[i].label);
						}
						let goodnatureNames = [];
						for (var i = 0; i < otherinfodata.natureofgoods.length; i++) {
							if(otherinfodata.natureofgoods[i]=="Others"){
								let str = "Others" +"-"+ otherinfodata.natureofgoodsothers;
								goodnatureNames.push(str);
							}else{
								goodnatureNames.push(otherinfodata.natureofgoods[i]);
							}
						}
						this.productData = [{
			          type: "label",
			          key: "Product Categories",
			          value: productcategories.join(", ")
			        },
							{
			          type: "label",
			          key: "Nature of Goods ",
			          value:  goodnatureNames.join(", ")
			        },{
			          type: "label",
			          key: "Average Shipment Weight (kg)",
			          value: otherinfodata.avgshipmentwt
					     }]
							 if (productcategories.some(e => e === 'Miscellaneous')) {
								 this.productData.push({
		 			          type: "label",
		 			          key: "Miscellaneous Description",
		 			          value: otherinfodata.describeother
		 			        })
							 }
					}else {
						this.productData = null;
					}

					if (otherinfodata.damagerisk != undefined || otherinfodata.isfragile != undefined
						||  otherinfodata.isliquid != undefined) {

						let damageRisk = 'N/A';
						let isfragile = 'N/A';
						let isliquid = 'N/A';
						let flashpoint = 'N/A';
						if (otherinfodata.damagerisk != undefined) {
							if(otherinfodata.damagerisk==1){
								damageRisk = 'High';
							}else{
								damageRisk = 'Low';
							}
						}
						if (otherinfodata.isfragile != undefined) {
						  if (otherinfodata.isfragile == 1) {
						    isfragile = 'Yes'
						  }
						}
						if (otherinfodata.isliquid != undefined) {
						  if (otherinfodata.isliquid == 1) {
						    isliquid = 'Yes'
						  }
						}
						if (otherinfodata.flashpoint != undefined) {
							flashpoint = otherinfodata.flashpoint
						}

						this.safetyInfoData = [{
							type: "label",
							key: "Damage Risk",
							value: damageRisk
						},{
							type: "label",
							key: "Product fragile",
							value: isfragile
						},{
							type: "label",
							key: "Product liquid",
							value: isliquid
						},{
							type: "label",
							key: "Flash Point (Celsius)",
							value: flashpoint
						}]
					}else {
						this.safetyInfoData = null;
					}

					if (otherinfodata.riskoftheft != undefined) {
						let riskoftheft;
						if(otherinfodata.riskoftheft==1){
							riskoftheft = "High";
						}else if(otherinfodata.riskoftheft==2){
							riskoftheft = "Medium";
						}else{
							riskoftheft = "Low";
						}
						this.securityInfoData = [{
							type: "label",
							key: "Risk of theft/pilferage",
							value: riskoftheft
						},
						{
							type: "label",
							key: "Product Value per kg",
							value: otherinfodata.productvalue
						}]
					}

					let tableData = [];
					if (otherinfodata.clientotherinfoboxdimentions != undefined && otherinfodata.clientotherinfoboxdimentions.length > 0) {
						for (var i = 0; i < otherinfodata.clientotherinfoboxdimentions.length; i++) {
							let dim = otherinfodata.clientotherinfoboxdimentions[i].dimension;
							let dimension = `L : ${dim.L} B : ${dim.B} H : ${dim.H}`;
							tableData.push({
								"Product" : otherinfodata.clientotherinfoboxdimentions[i].productcategory,
								"Box Type" : otherinfodata.clientotherinfoboxdimentions[i].boxtype,
								"Stacking Level" : otherinfodata.clientotherinfoboxdimentions[i].stackinglevel,
								"Box Strength" : otherinfodata.clientotherinfoboxdimentions[i].boxstrength,
								"Dimensions(cm)" : dimension,
								"Avg Physical Wt" : otherinfodata.clientotherinfoboxdimentions[i].avgphysicalwt,
								"HSN Code" : otherinfodata.clientotherinfoboxdimentions[i].hsn
							})
						}
					}
					if (tableData.length > 0) {
						let uom;
						if(otherinfodata.uom == 'cm'){
							uom = 'Centimeter (cm.)';
						}else if(otherinfodata.uom == 'in'){
							uom = 'Inch (in.)';
						}

						this.boxDimestionData = [
							{
								type: "detail",
								key: "Preferred UOM for box dimensions",
								value: uom
							},
							{
							type: "table",
							key: ["Product", "Box Type", "Stacking Level"
							,"Box Strength","Dimensions(cm)","Avg Physical Wt",'HSN Code'],
							value: tableData
							}
						];
					}else {
						this.boxDimestionData = null;
					}

					let projectionTableData = [];
					if (otherinfodata.yearlysalesprojection != undefined && otherinfodata.yearlysalesprojection.length > 0) {
						for (var i = 0; i < otherinfodata.yearlysalesprojection.length; i++) {
							projectionTableData.push({
								"Month" : otherinfodata.yearlysalesprojection[i].month,
								"Year" : otherinfodata.yearlysalesprojection[i].year,
								"Projected Sales(Tonnes)" : otherinfodata.yearlysalesprojection[i].sales,
							})
						}
					}
					if (otherinfodata.expectedyield != undefined && projectionTableData.length > 0) {
						this.commercialProjectionsData = [
							{
								type: "label",
								key: "Expected Yield per kg",
								value: otherinfodata.expectedyield
							},
							{
								type: "heading",
								key: "Yearly Sales Projection (Tonnes)",
								value: [{
								type: "table",
								key: ["Month", "Year", "Projected Sales(Tonnes)"],
								value: projectionTableData
								}]
							},
							{
								type: "label",
								key: "Annual Contract Revision",
								value: (otherinfodata.isannualcontractrevision==1)?"Yes":"No"
							},
							{
								type: "label",
								key: "% Revision on Base Rate",
								value: otherinfodata.revisionpercentage
							},
						];
					}else {
						this.commercialProjectionsData = null;
					}

					if (otherinfodata.manifestdatauploadmethod != undefined && otherinfodata.manifestdatauploadmethod.length > 0) {
						let manifestmethod = [];
						for (var i = 0; i < otherinfodata.manifestdatauploadmethod.length; i++) {
							if(otherinfodata.manifestdatauploadmethod[i]=='APIIntegration'){
								manifestmethod.push("API Integration");
							}
							if(otherinfodata.manifestdatauploadmethod[i]=='ManualBooking'){
								manifestmethod.push("Manual Booking");
							}
							if(otherinfodata.manifestdatauploadmethod[i]=='SoftDataUpload'){
								manifestmethod.push("Soft Data Upload");
							}
						}
						this.manifestData = [{
							type: "detail",
							key: "Manifest Methods",
							value: manifestmethod.join(", ")
						}]
					}else {
						this.manifestData = null;
					}
					this.isLoading = false;

				}else {
					this.productData = null;
					this.safetyInfoData = null;
					this.securityInfoData = null;
					this.boxDimestionData = null;
					this.commercialProjectionsData = null;
					this.manifestData = null;
					this.isLoading = false;
				}
			}else {
				this.$alert("Internal","Client","error");
				this.productData = null;
				this.safetyInfoData = null;
				this.securityInfoData = null;
				this.boxDimestionData = null;
				this.commercialProjectionsData = null;
				this.manifestData = null;
				this.isLoading = false;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/clientlisting/clienteview/otherinformation/otherinformation.component.js